<template>
    <div class="work safe-distance-top">
        <div class="work_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">工作经历</div>
            <div class="determine" @click="determine">提交</div>
        </div>
        <div class="work_bottom">
            <van-field
                v-model="message"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人工作经历"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "work",
    data() {
        return {
            message: "",
            // 工作经历 7
            workId: "",
        };
    },
    created() {
        this.workId = this.$route.query.workId;
    },
    mounted() {
        // 回显
        this.message = JSON.parse(sessionStorage.getItem("workcontent"));
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            if (this.message == "") {
                Toast("不能为空");
            } else {
                this.addOrEditExperience();
                window.history.go(-1);
            }
        },
        // 保存提交
        async addOrEditExperience() {
            let res = await this.$apis.userServe.addOrEditExperience({
                content: this.message,
                id: this.workId,
                type: 9,
            });
            if (res.data.resultCode == 200) {
                Toast("提交成功");
            } else {
                Toast(res.data.resultDesc);
            }
            console.log("是否成功?", res);
        },
    },
};
</script>

<style lang="scss" scoped>
.work {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .work_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .work_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
